import type { SVGProps } from "react";

/**
 * Единая иконка «Отправить» для чата, статусов, ответа на статус.
 * Меняешь SVG только здесь — везде обновится после сборки / HMR.
 */
export function SendIcon({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...rest}
    >
      <g fill="none">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M5.323 19.878l14.429-6.699c.998-.463.998-1.897 0-2.36l-14.429-6.697c-1.035-.48-2.13.538-1.743 1.621l2.233 6.254-2.233 6.261c-.387 1.082.708 2.1 1.743 1.62Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M5.81 12h14.69"
        />
      </g>
    </svg>
  );
}
